import  ProfileOptionsHeader  from '../ProfileOptionsHeader';
import { ProfileOptionsNavItem } from '../ProfileOptionsNavItem';
import { useLocation, useNavigate } from "react-router-dom";
import * as S from './styles';
import { _UserData } from '../../../infra/storage/localStorage';
import { RootStateBase } from '../../../store/baseStore';
import { useTheme } from '../../../utils/context/themeContext';
import { connectState, PropsFromRedux } from "base/src/utils/reduxUtil";
import Divider from '../../Divider';

const connector = connectState(
  (state: RootStateBase) => ({
    sideBarList: state.UtilReducer.SideBarList,
  })
);

export interface ProfileOptionsNavProps extends PropsFromRedux<typeof connector> {}

function ProfileOptionsNav(props: PropsFromRedux<typeof connector>){
  const { theme } = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const homePage = props.sideBarList && props.sideBarList.find(e => e.home == true)

  function exit () {
    _UserData.LogOut()
  }

  function home () {
    if (props.sideBarList != null && props.sideBarList.length > 0) {
      if (homePage != null && location.pathname != homePage.LinkTo) {
        navigate(homePage.LinkTo)
        return
      }
    }
  }

  return (
    <S.Container>
      <S.ContainerHeader>
        <ProfileOptionsHeader />
        <Divider orientation='horizontal' color={theme.colors.text} />
      </S.ContainerHeader>
      {props.sideBarList != null && homePage != undefined &&
        <ProfileOptionsNavItem aria-disabled={homePage.LinkTo == location.pathname} onClick={home} iconName='ic:round-home'>Início</ProfileOptionsNavItem>
      }
      <ProfileOptionsNavItem onClick={exit} iconName='ic:baseline-log-in'>Sair</ProfileOptionsNavItem>
      {/* <ProfileNavbarOptions /> */}
    </S.Container>
  )
}

export default connector(ProfileOptionsNav);